<template>
    <section>
        <div id="order_view_model" class="modal fade" role="dialog" ref="viewOrderModal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                        <h4 class="modal-title">
                            <b class="pull-left">Order #: {{order.id}}</b>
                            <b class="pull-right">Current Status: {{order.statusesByStatusId ? order.statusesByStatusId.name : 'N/A'}}</b>
                        </h4>
                        <br/>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="showActions === 'true'">
                            <div class="col-md-12">
                                <div class="btn-group open pull-right">
                                    <div data-toggle="dropdown" id="dropdown-toggle" v-bind:class="'btn btn-primary btn-xs ld-ext-right ' + actionBtnLoadingClass" aria-expanded="true">
                                        Actions
                                        <span class="caret"></span>
                                        <div class="ld ld-ring ld-spin"></div>
                                    </div>
                                    <ul class="dropdown-menu">
                                        <li v-if="order.statusesByStatusId && order.statusesByStatusId.id === 7 && userRole !== 'ROLE_BRANCH'"><a href="javascript:void(0)" v-on:click="pushOrderToBranch()">Re - Push Order To Branch</a></li>
                                        <li><a href="javascript:void(0)" v-on:click="showComplaintForm()">Register Complain</a></li>
                                        <li v-if="userRole !== 'ROLE_BRANCH' && canUpdateOrderStatus()"><a href="javascript:void(0)" v-on:click="showChangeOrderStatusForm()">Change Order Status</a></li>
                                        <li v-if="order.statusesByStatusId && order.statusesByStatusId.id === 10"><a href="javascript:void(0)" v-on:click="assignRider()">Assign Rider</a></li>
                                    </ul>
                                </div>
                              <button type="button" class="btn btn-warning pull-right btn-xs ld-ext-right mr-1" @click="printOrder" v-if="isBranchUser">Print</button>
                            </div>
                        </div>
                        <div v-if="(order.statusesByStatusId && (order.statusesByStatusId.id === 12 || order.statusesByStatusId.id === 9) && order.orderTypesByOrderTypeId.id === 1) || (order.statusesByStatusId && (order.statusesByStatusId.id === 12 || order.statusesByStatusId.id === 9) && order.orderTypesByOrderTypeId.id === 2)">
                            <legend>POS Details</legend>
                            Order Type: <b>{{order.orderTypesByOrderTypeId.type}}</b><br/>
                            <span v-if="order.table">Assigned Slot: <b>{{order.table.name}}</b><br></span>
                            <span v-if="order.waiter!=null && order.table">Assigned Waiter: <b>{{order.waiter.name}}</b></span><br><br>
                        </div>
                        <CustomerDetails v-else-if="order.orderSource && order.orderSource.id !== 7" ref="customerDetails" v-bind:order="order"/>
                        <div v-else>
                            <legend class="text-center text-danger">
                                <b>FoodPanda Order</b>
                            </legend>
                            Customer Name: <b>{{order.foodPandaDetails.customerName}}</b><br/>
                            Foodpanda Order#: <b>{{order.foodPandaDetails.foodPandaOrderId}}</b><br/>
                            <br/><br/>
                        </div>

                        <legend v-if="order.table===null && order.orderTypesByOrderTypeId.id!==1">Order Items - ({{ order.id === 0 ? 'Distance to cover by Rider' : 'Distance Covered By Rider' }}: <span class="badge badge-info">{{order.totalDistance}}</span> Km)</legend>
                        <legend v-else>Order Items</legend>
                        <table class="table table-bordered table-hover table-stripped">
                            <thead>
                            <tr>
                                <th class="text-center">Name</th>
                                <th class="text-center">Serving</th>
                                <th class="text-center">Price</th>
                                <th class="text-center">Quantity</th>
                                <th class="text-center">Total Price</th>
                                <th class="text-center">Special Instruction</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="(orderItem, orderItemIndex) in order.orderItemsById">
                                <tr  v-bind:key="orderItemIndex+'_'+orderItem.id">
                                    <td class="text-center">{{orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name}}</td>
                                    <td class="text-center">{{orderItem.menuItemTypesByMenuItemTypeId.serving}}</td>
                                    <td class="text-center">{{orderItem.menuItemTypesByMenuItemTypeId.price}}</td>
                                    <td class="text-center">{{orderItem.quantity}}</td>
                                    <td class="text-center">{{orderItem.totalPrice}}</td>
                                    <td class="text-center text-danger">{{orderItem.instructions ? orderItem.instructions : 'N/A'}}</td>
                                </tr>
                                <template v-for="(itemAddOn, index) in orderItem.orderItemAddOnsById">
                                    <tr v-bind:key="index+'_'+orderItemIndex+'_'+itemAddOn.addOnItemsByAddOnItemId.name">
                                        <td colspan="3" class="text-right"><b>Add On</b></td>
                                        <td class="text-center">{{itemAddOn.addOnItemsByAddOnItemId.name}}</td>
                                        <td class="text-center">{{itemAddOn.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.name}}</td>
                                        <td class="text-center">{{(itemAddOn.quantity * itemAddOn.price) + ' => (' + itemAddOn.price + ' X ' + itemAddOn.quantity + ')'}}</td>
                                    </tr>
                                </template>
                            </template>
                            <tr>
                                <td colspan="5" class="text-right">Sub Total</td>
                                <td class="text-right">{{order.totalPrice | formatNumber}} Rs.</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Sub Total With AdOn'S</td>
                                <td class="text-right">{{order.totalPriceWithAddon | formatNumber}} Rs.</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Tax Amount<b v-if="order.paymentMethod!==null && order.paymentMethod==='cash'" class="text-info">({{order.branchesByBranchId.tax}}%)</b><b v-if="order.paymentMethod!==null && order.paymentMethod==='card'" class="text-info">({{order.branchesByBranchId.cardTax}}%)</b></td>
                                <td class="text-right">{{Math.round(this.order.totalPriceAfterTax- (this.order.totalPriceWithAddon - (this.order.orderSource && this.order.orderSource.id === 9 ? 0 : this.order.discount)))}} Rs.</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Sub Total After Tax</td>
                                <td class="text-right">{{order.totalPriceAfterTax | formatNumber}} Rs.</td>
                            </tr>
                            <tr v-if="!order.branchesByBranchId.freeDelivery && order.table===null">
                                <td colspan="5" class="text-right">Delivery Fee</td>
                                <td class="text-right">{{order.deliveryFee | formatNumber}} Rs.</td>
                            </tr>
                            <tr>
                              <td colspan="5" class="text-right">Loyalty Points</td>
                              <td class="text-right" >{{order.loyaltyPoints | formatNumber}} Rs.</td>
                            </tr>
                            <tr v-if="order.branchesByBranchId.freeDelivery && order.table===null">
                                <td colspan="4" class="text-right">Delivery Fee</td>
                                <td><b class="label label-danger">Not Charged To Customer</b></td>
                                <td class="text-right">{{order.deliveryFee | formatNumber}} Rs.</td>
                            </tr>
                            <tr>
                              <td :colspan="couponApplied ? 4 : 5" class="text-right">Discount</td>
                              <td class="center" v-if="couponApplied">
                                <span class="label label-info">({{order.couponsByCouponId.couponCode}}) - ({{(order.couponsByCouponId.inPercentage) ? order.couponsByCouponId.discount + "%" : order.couponsByCouponId.discount + ".RS" }})</span>
                              </td>
                                <td class="text-right" >{{order.discount | formatNumber}} Rs.</td>
                            </tr>
                            <tr>
                              <td colspan="5" class="text-right">Total Discount</td>
                              <td class="text-right" >{{order.discount + order.loyaltyPoints | formatNumber}} Rs.</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Billed Price</td>
                                <td class="text-right" >{{order.billedPrice | formatNumber}} Rs.</td>
                            </tr>
                            <tr v-if="order.paymentMethod!==null">
                                <td colspan="5" class="text-right">Payment Method</td>
                                <td class="text-right" >{{(order.paymentMethod !== null) ? order.paymentMethod.name : "N/A"}}</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Payment Status</td>
                                <td class="text-right" >{{ (order.paymentStatus !== null) ? order.paymentStatus.name: "N/A"}}</td>
                            </tr>
                            <tr v-if="order.table!==null">
                                <td colspan="5" class="text-right">Cash Taken</td>
                                <td class="text-right" >{{order.cashTaken | formatNumber}} Rs.</td>
                            </tr>
                            <tr v-if="order.table!==null">
                                <td colspan="5" class="text-right">Cash Given</td>
                                <td class="text-right" >{{order.cashGiven | formatNumber}} Rs.</td>
                            </tr>                            
                            </tbody>
                        </table>
                        <!--<span th:if="*{rider != null}">-->
                        <!--<legend>Rider Details</legend>-->
                        <!--<span>Name: <b th:text="*{rider.name}"></b></span><br/>-->
                        <!--<span>Contact <b th:text="*{rider.contact1}"></b></span><br/>-->
                        <!--<span>CNIC: <b th:text="*{rider.cnic}"></b></span><br/>-->
                        <!--<span>Vehicle Number: <b th:text="*{rider.vehicleNumber}"></b></span>-->
                        <!--</span>-->

                        <legend>Order Wide Instructions</legend>
                        <span class="text-danger">
                          <b>{{(order.orderWideInstructions != null ) ? order.orderWideInstructions : "No Order Wide Instructions"}}</b>
                        </span>
                        <br/><br/>
                        <div v-if="order.dvmAddress !== null">
                          <div class="row custom_styling_on_row">
                            <legend :class="(order.ordersRating !== null) ? 'col-md-4 order_feedback' : ''">
                              {{$store.getters.getValidPlatform}} Order Feedback
                            </legend>
                            <legend v-if="order.ordersRating !== null" class="col-md-8 order_feedback">
                              <StarRating class="pull-right"
                                          :rating="order.ordersRating.rating"
                                          :read-only="true"
                                          :star-size="20"
                                          :show-rating="false"
                                          :increment="0.01"
                                          :title="OrderRatingTitle">
                              </StarRating>
                            </legend>
                          </div>
                          <span class="text-justify">
                              {{(order.ordersRating !== null && order.ordersRating.feedbackText !== null ) ? order.ordersRating.feedbackText : "No Feedback Available"}}
                          </span>
                          <br/><br/>
                        </div>
                        <div class="row">
                          <div v-bind:class="(order.ridersByRiderId === null)? 'full_legend' : 'col-md-8 pull-left half_legend'">
                            <legend>Restaurant</legend>
                            <span>Name: <b>{{order.branchesByBranchId.restaurantsByRestaurantId.name}}</b></span><br/>
                            <span>Branch: <b>{{order.branchesByBranchId.areasByAreaId.name}}</b></span><br/>

                            <span>Phone 1: <b>{{(order.branchesByBranchId.phone1 !== "") ? order.branchesByBranchId.phone1 :"N/A"}}</b></span><br/>
                            <span>Contact Name 1:
                              <b>
                                {{(order.branchesByBranchId.contactName1 !== "" && order.branchesByBranchId.contactName1 !== null) ? order.branchesByBranchId.contactName1 :"N/A"}}
                              </b>
                            </span>
                            <br/>

                            <span>Phone 2: <b>{{(order.branchesByBranchId.phone2 !== "") ? order.branchesByBranchId.phone2 :"N/A"}}</b></span><br/>
                            <span>
                              Contact Name 2:
                              <b>
                                {{(order.branchesByBranchId.contactName2 !== "" && order.branchesByBranchId.contactName2 !== null) ? order.branchesByBranchId.contactName2 :"N/A"}}
                              </b>
                            </span>
                            <br/>

                            <span>Phone 3: <b>{{(order.branchesByBranchId.phone3 !== "") ? order.branchesByBranchId.phone3 :"N/A"}}</b></span><br/>
                            <span>
                              Contact Name 3:
                              <b>
                                {{(order.branchesByBranchId.contactName3 !== "" && order.branchesByBranchId.contactName3 !== null) ? order.branchesByBranchId.contactName3 :"N/A"}}
                              </b>
                            </span>
                            <br/>
                          </div>
                          <div class="branch col-md-4 pull-right" v-if="order.ridersByRiderId">
                            <legend>Assigned Rider</legend>
                            <span>Name: <b>{{order.ridersByRiderId.name}}</b></span><br>
                            <span>Contact Number: <b>{{order.ridersByRiderId.contact}}</b></span><br>
                            <span>Vehicle Number: <b>{{order.ridersByRiderId.vehicleNumber}}</b></span>
                          </div>
                        </div>
                        <br/><br/>
                        <div v-if="order.usersByUserId!==null">
                            <legend>Order Taken By:</legend>
                            <span>Name: <b >{{order.usersByUserId.fullName}}</b></span><br/>
                            <span>Contact <b>{{order.usersByUserId.contact}}</b></span><br/>
                            <span>Email: <b>{{order.usersByUserId.email}}</b></span><br/>
                            <br/><br/>
                        </div>
                        <div v-if="order.table===null && order.orderTypesByOrderTypeId.id!==1">
                            <legend>Estimated Delivery Time: {{order.expectedDeliveryMinutes ? order.expectedDeliveryMinutes+' Min' : "N/A"}}</legend>

                            <br/><br/>
                        </div>
                        <legend>Order History {{order.orderHistoriesById.length > 0 ? '' : ": N/A"}}</legend>
                        <table class="table table-bordered table-hover table-condensed">
                            <thead>
                                <tr>
                                    <th class="text-center">Status</th>
                                    <th class="text-center">Created</th>
                                    <th class="text-center">User</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(history, hIndex) in order.orderHistoriesById" v-bind:key="'historyKey'+history.created +'_'+ hIndex">
                                    <td class="text-center">
                                        <span v-bind:class="'label ' + history.statusesByStatusId.cssClass">{{history.statusesByStatusId.name}}</span>
                                    </td>
                                    <td class="text-center" >
                                        <span v-bind:class="'label ' + history.statusesByStatusId.cssClass" >{{history.statusesByStatusId.name==='CREATED' ? $moment.parseZone(String(history.posCreated)).local().format('DD/MM/YYYY hh:mm:ss A'): $moment.parseZone(String(history.created)).local().format('DD/MM/YYYY hh:mm:ss A')}}</span>
                                    </td>
                                    <td class="text-center" >
                                      <span v-bind:class="'label ' + history.statusesByStatusId.cssClass" >
                                        {{ history.usersByUserId !== null ? history.usersByUserId.fullName : "N/A"}}
                                      </span>
                                    </td>
                            </tr>
                            </tbody>
                        </table>
                        <section v-if="order.statusesByStatusId && order.statusesByStatusId.id === 9">
                            <br/><br/>
                            <legend>Cancel Reasons</legend>
                            <label><b class="text-danger">{{(order.orderCancellationReasonsId.id===4) ? order.otherCancelReasons : order.orderCancellationReasonsId.reason}}</b></label>
                        </section>

                        <section v-if="showActions === 'true' && order.complaints.length > 0">
                            <br/><br/>
                            <legend>Order Complaints</legend>
                            <div class="list-group">
                                <a class="list-group-item" v-for="(complaint, cIndex) in order.complaints" v-bind:key="'viewOrderComplaint_'+complaint.id + '_' + cIndex">
                                    <h3 class="list-group-item-heading">
                                        Created On: <small>{{complaint.created}}</small>
                                        <span class="pull-right">{{complaint.status + ' => (' + complaint.id + ')'}}</span>
                                    </h3>
                                    <p class="list-group-item-text">{{complaint.complaint}}</p>
                                    <ul class="list-inline" v-if="userRole === 'ROLE_AGENT' && complaint.requestOfAction === 0">
                                        <li><a v-on:click="doActionOnComplaint(1, cIndex)">Request To Resolve</a></li>
                                        <li><a v-on:click="doActionOnComplaint(2, cIndex)">Request To Ignore</a></li>
                                    </ul>
                                    <ul class="list-inline" v-if="complaint.requestOfAction !== 0">
                                        <li>Mr. {{complaint.actionRequestedBy}} has requested to
                                            <b>{{(complaint.requestOfAction === 1) ? 'Resolve' : 'Ignore'}}</b> this complaint</li>
                                    </ul>
                                </a>
                            </div>
                        </section>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" v-if="punchOrderButton" v-on:click="$parent.saveOrder()">Punch Order</button>
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
        <OrderComplaint v-bind:orderId="order.id"  />
        <ChangeOrderStatus :statuses="orderStatuses"
                           v-bind:orderId="order.id"
                           :current-status-id="(order.statusesByStatusId !== null) ? order.statusesByStatusId.id : 0"
                           :order-type-id="order.orderTypesByOrderTypeId.id"
                           :restaurantId="this.order.branchesByBranchId.restaurantsByRestaurantId.id"
        />
        <AssignRider ref="assignRiderModal" />
        <PrintOrder :order="order" id="print-order" style="display:none"/>
    </section>
</template>

<script>
    /* eslint-disable */
    import OrderComplaint from "@/components/complaints/OrderComplaint";
    import ChangeOrderStatus from "./ChangeOrderStatus";
    import AssignRider from "@/components/riders/AssignRider"
    import CustomerDetails from "./CustomerDetails"
    import StarRating from 'vue-star-rating';
    import {updateCustomDeliveryFeeAndLoyaltyPoints} from "@/api/orders";
    import PrintOrder from "@/components/orders/PrintOrder";

    export default {
        name: "ViewOrder",
        components: {
            PrintOrder,
            ChangeOrderStatus,
            OrderComplaint,
            AssignRider,
            CustomerDetails,
            StarRating,
        },
        props: {
            showActions: String,
            orderStatuses: Array,
        },
        data: function() {
            return {
                userRole: "",
                actionBtnLoadingClass: "",
                OrderRatingTitle: "",
                order: {
                    "id": 0,
                    "totalPrice": 0,
                    "discount": 0,
                    "billedPrice": 0,
                    "created": "",
                    "modified": "",
                    "deliveryFee": 0,
                    "cancelReasons": null,
                    "commission": null,
                    "totalDistance": 5,
                    "totalPriceAfterTax": 0,
                    "totalPriceWithAddon": 0,
                    "pushTries": 1,
                    "complaints": [],
                    "table":null,
                    "waiter":{
                        "name":""
                    },
                    "orderHistoriesById": [
                        {
                            "created": "",
                            "statusesByStatusId": {
                                "id": 10,
                                "name": "",
                                "cssClass": ""
                            },
                          "usersByUserId": {
                            "branch": null,
                            "contact": "",
                            "email": "",
                            "fullName": "",
                            "id": 0,
                            "restaurant": null,
                            "username": "",
                          }
                        }
                    ],
                    "orderItemsById": [
                        {
                            "id": 1,
                            "quantity": 0,
                            "totalPrice": 0,
                            "instructions": "",
                            "orderItemAddOnsById": [
                                {
                                    "id": 1,
                                    "quantity": 0,
                                    "addOnItemsByAddOnItemId": {
                                        "id": 1,
                                        "name": "",
                                        "price": 0,
                                        "addOnCategoriesByAddOnCategoryId": {
                                            "name": "",
                                            "allowedItems": 1
                                        }
                                    }
                                }
                            ],
                            "menuItemTypesByMenuItemTypeId": {
                                "price": 199,
                                "serving": "",
                                "menuItemsByMenuItemId": {
                                    "id": 145,
                                    "name": "",
                                    "description": "",
                                    "menuCategoriesByMenuCategoryId": {
                                        "name": ""
                                    }
                                }
                            }
                        }
                    ],
                    "branchesByBranchId": {
                        "freeDelivery": true,
                        "tax": 16,
                        "restaurantsByRestaurantId": {
                            "name": ""
                        },
                        "areasByAreaId": {
                            "name": "",
                            "citiesByCityId": {
                                "city": ""
                            }
                        }
                    },
                    "statusesByStatusId": {
                        "id": 0,
                        "name": "",
                        "cssClass": "label-success"
                    },
                    "foodPandaDetails": {
                      "id": 0,
                      "customerName": "",
                      "foodPandaOrderId": ""
                    },
                    "customerAddressesByCustomerAddressId": {
                        "address": "",
                        "customersByCustomerId": {
                            "name": "",
                            "contact1": "",
                            "contact2": null,
                            "contact3": null,
                            "email": ""
                        },
                        "areasByAreaId": {
                            "name": "",
                            "citiesByCityId": {
                                "city": ""
                            }
                        }
                    },
                    "couponsByCouponId": null,
                    "usersByUserId": {
                        "id": 50,
                        "username": "",
                        "fullName": "",
                        "contact": "",
                        "email": ""
                    },
                    "orderTypesByOrderTypeId": {
                        "type": "Delivery"
                    },
                    "ordersRating": null,
                    "paymentMethod": {
                        "id":'',
                        "name":''
                    },
                    "paymentStatus":{
                        "id":'',
                        "name":''
                    }
                },
                punchOrderButton: false
            }
        },
        computed: {
          isBranchUser(){
            return this.$store.state.user && this.$store.state.user.userRolesById  && this.$store.state.user.userRolesById[0].role === 'ROLE_BRANCH'
          },
         couponApplied() {
           return this.order.couponsByCouponId !==null;
          }
        },
        created: function () {
            let loggedInUser = this.$store.state.user;
            if(loggedInUser){
                this.userRole = loggedInUser.userRolesById[0].role;
            }
        },
        mounted: function() {
          if(this.$parent.dtTable !== undefined) {
            $("#order_view_model").on('hidden.bs.modal', (e) => {
              this.$parent.dtTable.draw();
            });
          }
          $("#star-rating").tooltip({placement:"right"});
          $('#dropdown-toggle').dropdown('toggle');
        },
        methods: {
            fetchOrderDetail: function (orderId) {
                if (!orderId) return
                let params = new URLSearchParams();
                params.append('order_id', orderId);
                this.$http.post(this.$store.state.mainAppURL + "orders/get_order_detail", params).then( (response) => {
                    this.order = response.data;
                    if(this.order.ordersRating !== null && this.order.ordersRating.rating !== null) {
                      this.OrderRatingTitle = "Order Rating: " + this.order.ordersRating.rating;
                    }
                    console.log("Order: ", this.order);
                    $("#order_view_model").modal("show");
                }).catch(function (error) {
                    console.log(error);
                });
            },
            showComplaintForm: function (){
                $("#complaint_modal").modal("show");
            },
            showChangeOrderStatusForm: function () {
                $("#changeOrderStatusModal").modal("show");
            },
            pushOrderToBranch: function () {
                let params = new URLSearchParams();
                params.append('order_id', this.order.id);
                this.actionBtnLoadingClass = "running";
                this.$http.post(this.$store.state.mainAppURL + "orders/push_order_to_branch", params).then(resp => {
                   if(resp.data){
                       swal("SUCCESS!", "Order has been successfully pushed", "success");
                   }else{
                       swal("ERROR!", "There is some error in pushing order to branch! Please try again.", "error");
                   }
                    this.actionBtnLoadingClass = "";
                });
            },
            doActionOnComplaint: function (action, cIndex) {
                let complaint = this.order.complaints[cIndex];
                swal({
                    title: "Complaint Solution / Notes",
                    text : "Please Enter Complaint Solution / Notes.",
                    type: "info",
                    input: 'textarea',
                    inputPlaceholder: "Notes...",
                    showCancelButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: "REQUEST!",
                    showLoaderOnConfirm: true,
                    preConfirm: (notes) => {
                        return notes;
                    },
                }).then( (result) => {
                    console.log(result);
                    if(result.value){
                        complaint["orders"] = {};
                        complaint["orders"].id = complaint["orderId"];
                        complaint.requestOfAction = action;
                        complaint.actionRequestedBy = this.$store.state.user["fullName"];
                        complaint.actionRequestedOn = new Date();
                        complaint.complaintSolution = result.value;
                        this.$http.post(this.$store.state.mainAppURL + "complaints/register_generic_complaint", complaint).then( (response) => {
                            if(response.data){
                                swal("SUCCESS!","Your request has been sent to admin", "success");
                            }else{
                                swal("ERROR!","Error! Contact Musab Bukahri", "error");
                            }
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }
                });

            },

            async updateDeliveryFeeAndLoyaltyPoints(contact, customDeliveryCharges, loyaltyPoints) {
              try {
                let params = new FormData();
                params.append("caller_number",contact);
                params.append("custom_delivery_charges",customDeliveryCharges);
                params.append("loyalty_points",loyaltyPoints);
                await updateCustomDeliveryFeeAndLoyaltyPoints(params)
              } catch (e) {
                console.log(e)
              }
            },

            async fetchOrderToPunchDetail (contact, customDeliveryCharges, loyaltyPoints) {
              console.log('customDeliveryCharges', customDeliveryCharges)
              console.log('loyaltyPoints', loyaltyPoints)
              await this.updateDeliveryFeeAndLoyaltyPoints(contact, customDeliveryCharges, loyaltyPoints)
                this.punchOrderButton = true;
                let params = new URLSearchParams();
                params.append("contact_number",contact);
                this.$http.post(this.$store.state.mainAppURL + "orders/check_delivery_order_request", params).then(resp => {
                    if(resp.data === null || resp.data === ""){
                        swal("Error!", "No Order data to show!", "error");
                        return;
                    }else if(resp.data.orderSource.id === 7 &&
                        (resp.data.foodPandaDetails.customerName === null || resp.data.foodPandaDetails.foodPandaOrderId === null)
                    ){
                        swal("Error", "Enter Foodpanda Details!", "error");
                        return;
                    }else{
                        this.order = resp.data
                    }
                    $("#order_view_model").modal("show");
                }).catch(function (error) {
                    console.log(error);
                });
            },
            assignRider: function(){
                console.log(this.order.branchesByBranchId.id);
                console.log(this.order.branchesByBranchId.restaurantsByRestaurantId.name);
                this.$refs.assignRiderModal.load(this.order, $("#order_view_model"))
            },
            canUpdateOrderStatus: function (){
              let loggedInRole = this.$store.getters.user.userRolesById && this.$store.getters.user.userRolesById[0].role;
              let isAdmin = (loggedInRole === 'ROLE_ADMIN');
              let isAgent = (loggedInRole === 'ROLE_AGENT');
              let isManager = (loggedInRole === 'ROLE_MANAGER');
              let statusId = this.order.statusesByStatusId.id;
              let restaurantId = this.order.branchesByBranchId.restaurantsByRestaurantId.id;
              return (restaurantId === 37 || restaurantId === 40) || (((statusId === 7 || statusId === 2 || statusId === 10 || statusId === 22 ) && (isAgent || isAdmin || isManager)) ||
                  (statusId === 25 && isAdmin)) || statusId === 12
            },
            printOrder() {
              const WinPrint =window.open('', '', 'left=0,top=0,width=400,height=500px,toolbar=0,scrollbars=0,status=0');
              WinPrint.document.write(document.getElementById('print-order').innerHTML) ;
              WinPrint.document.close();
              WinPrint.focus();
              WinPrint.print();
              window.e = WinPrint;
              console.log('printing');
              setTimeout(()=>{
                WinPrint.close();
              },500)
              console.log('closing')
          }
        }
    }
</script>

<style scoped>
.modal { overflow: auto !important; }
.branch {
  padding-left: 0;
  padding-right: 15px;
}
.half_legend {
  padding-right: 0;
  padding-left: 15px;
}
.full_legend{
  padding-right: 15px;
  padding-left: 15px
}
.custom_styling_on_row{
  margin-left: 0;
  margin-right: 0;
}
.order_feedback{
  padding-left: 0;
  padding-right: 0;
}
.center{
  display: flex;
  justify-content: center;
}
.mr-1{
  margin-right: 1rem;
  width: 6rem;
}
</style>
